import { render } from "./login.vue?vue&type=template&id=39123148&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=39123148&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39123148"

export default script